import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const ContentContext = createContext(null);

export const ContentProvider = ({ children }) => {
  const [siteContent, setSiteContent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchContent = useCallback(async () => {
    try {
      const { data } = await axios.get('/api/content', {
        headers: { 'Cache-Control': 'no-cache' },
        params: { t: Date.now() },
      });
      if (!data || typeof data !== 'object') {
        throw new Error('Invalid content response from backend');
      }
      setSiteContent(data);
      setError(null);
      return data;
    } catch (err) {
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchContent().catch(() => {});

    const interval = window.setInterval(() => {
      fetchContent().catch(() => {});
    }, 60000);

    const handleVisibility = () => {
      if (document.visibilityState === 'visible') {
        fetchContent().catch(() => {});
      }
    };

    document.addEventListener('visibilitychange', handleVisibility);
    return () => {
      window.clearInterval(interval);
      document.removeEventListener('visibilitychange', handleVisibility);
    };
  }, [fetchContent]);

  return (
    <ContentContext.Provider value={{ siteContent, loading, error, refreshContent: fetchContent }}>
      {children}
    </ContentContext.Provider>
  );
};
export const useContent = () => {
  const ctx = useContext(ContentContext);
  if (!ctx) throw new Error('useContent must be used within ContentProvider');
  return ctx;
};
